import { Pipe, PipeTransform } from '@angular/core';

const CPF_LENGTH = 11;
const FIRST_GROUP_END_INDEX = 3;
const SECOND_GROUP_END_INDEX = 6;
const THIRD_GROUP_END_INDEX = 9;

@Pipe({
    name: 'cpfFormat',
    standalone: true,
})
export class CpfFormatPipe implements PipeTransform {
    transform(value: number | string): any {
        const stringValue = (value ?? '').toString();
        if (stringValue === '') {
            return '';
        }
        return stringValue.length === CPF_LENGTH
            ? `${stringValue.slice(0, FIRST_GROUP_END_INDEX)}.${stringValue.slice(FIRST_GROUP_END_INDEX, SECOND_GROUP_END_INDEX)}.${stringValue.slice(SECOND_GROUP_END_INDEX, THIRD_GROUP_END_INDEX)}-${stringValue.slice(THIRD_GROUP_END_INDEX, CPF_LENGTH)}`
            : stringValue;
    }
}
